import {Component, OnInit} from '@angular/core';
import {AppStateService} from './shared/app-state.service';
import {delay, filter} from 'rxjs/operators';
import {NavigationStart, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AnalyticsService} from './shared/analytics.service';

@Component({
  selector: 'client-app',
  templateUrl: './client-app.component.html',
  styleUrls: ['./client-app.component.scss']
})
export class ClientAppComponent implements OnInit {

  // This is delayed to prevent change detection from breaking.
  // https://github.com/angular/angular/issues/23522
  loading$ = this.AppState.loading$.pipe(delay(0));
  navStart: Observable<NavigationStart>;

  constructor(private AppState: AppStateService, private Router: Router, private Analytics: AnalyticsService) {
    this.navStart = Router.events.pipe(
      filter(evt => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;
  }

  ngOnInit() {
    this.navStart.subscribe(evt => this.Analytics.trackPageView({page: evt.url}));
  }
}
